export default __webpack_public_path__ + "9cad847dac19cecdf6e902a31938c0de.png";